import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Components/Layout";
import styles from "./styles/InnerPage.module.css";

const Tick = () => <span style={{ color: "#2e9d5b", fontWeight: 900 }}>✔</span>;
const Cross = () => <span style={{ color: "#b43c3c", fontWeight: 900 }}>✖</span>;

export default function Subscribe() {
  const navigate = useNavigate();
  const goCheckout = (plan) => navigate(`/subscribe/checkout?plan=${plan}`);

  return (
    <Layout imageUrl="https://mychinesehoroscope.com/my-chinese-horoscope-finder.png">
      <div className={styles.page}>
        <div className={styles.container}>
          {/* ✅ same inner-page header style */}
          <header className={styles.hero}>
            <p className={styles.kicker}>MyChineseHoroscope.com</p>
            <h1 className={styles.h1}>Subscribe</h1>
            <p className={styles.sub}>
              Choose a plan to unlock your <strong>Yearly Chinese Horoscope Readings</strong> and updates on your zodiac and element sign , deeper readings, and compatibility insights.
            </p><p> Go back to <a href='https://mychinesehoroscope.com' title='My Chinese Horoscope'>My Chinese Horoscope</a> Finder.</p>
          </header>

          {/* ✅ keeps your existing layout, but inside the framed page */}
          <section className={styles.card}>
            <h2 className={styles.sectionTitle} style={{ textAlign: "center", marginTop: 0 }}>
              Choose your plan
            </h2>

            <p className={styles.p} style={{ textAlign: "center", opacity: 0.85 }}>
              Subscribe to access your <strong>Chinese Element</strong>, detailed readings, and compatibility matches.
            </p>

            <div style={grid}>
              {/* MONTHLY */}
              <Plan
                title="$6 / month"
                badge="Most popular"
                onClick={() => goCheckout("monthly")}
                features={[
                  ["Chinese Zodiac animal", true],
                  ["Chinese Element match", true],
                  ["Star sign & element explanation", true],
                  ["Compatibility for all signs", true],
                  ["Monthly horoscope readings", true],
                  ["Auspicious year forecast", false],
                  ["Love & career outlook (yearly)", false],
                  ["Save multiple birthdays", false],
                ]}
              />

              {/* YEARLY */}
              <Plan
                title="$36 / year"
                subTitle="Only $3 / month"
                badge="Best value"
                onClick={() => goCheckout("yearly")}
                features={[
                  ["Chinese Zodiac animal", true],
                  ["Chinese Element match", true],
                  ["Star sign & element explanation", true],
                  ["Compatibility for all signs", true],
                  ["Monthly horoscope readings", true],
                  ["Auspicious year forecast", true],
                  ["Love & career outlook (this year)", true],
                  ["Save multiple birthdays", false],
                ]}
              />

              {/* LIFETIME */}
              <Plan
                title="$89.99 lifetime"
                badge="Unlimited"
                onClick={() => goCheckout("lifetime")}
                features={[
                  ["Chinese Zodiac animal", true],
                  ["Chinese Element match", true],
                  ["Star sign & element explanation", true],
                  ["Compatibility for all signs", true],
                  ["Monthly horoscope readings", true],
                  ["Auspicious year forecast", true],
                  ["Love & career outlook (all years)", true],
                  ["Save multiple birthdays", true],
                ]}
              />
            </div>

            <p style={{ marginTop: 20, fontSize: 13, opacity: 0.7, textAlign: "center" }}>
              Secure payment via Stripe. Cancel anytime (monthly / yearly).
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}

function Plan({ title, subTitle, badge, features, onClick }) {
  return (
    <div style={card}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
        <h3 style={{ margin: 0 }}>{title}</h3>
        {badge && <span style={badgeStyle}>{badge}</span>}
      </div>

      {subTitle ? (
        <div style={{ marginTop: 6, fontWeight: 900, color: "#810303", fontSize: 14 }}>
          {subTitle}
        </div>
      ) : null}

      <ul style={list}>
        {features.map(([label, ok], i) => (
          <li key={i} style={{ opacity: ok ? 1 : 0.5 }}>
            {ok ? <Tick /> : <Cross />} <span>{label}</span>
          </li>
        ))}
      </ul>

      <button onClick={onClick} style={cta}>
        Subscribe
      </button>
    </div>
  );
}

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 20,
  marginTop: 28,
};

const card = {
  background: "rgba(255,255,255,0.95)",
  borderRadius: 18,
  padding: 20,
  border: "1px solid rgba(0,0,0,0.12)",
  display: "flex",
  flexDirection: "column",
};

const badgeStyle = {
  fontSize: 12,
  fontWeight: 600,
  color: "#fff",
  padding: "4px 10px",
  borderRadius: 999,
  background: "rgb(248, 141, 0)",
  whiteSpace: "nowrap",
};

const list = {
  listStyle: "none",
  padding: 0,
  margin: "14px 0 18px",
  display: "grid",
  gap: 8,
};

const cta = {
  marginTop: "auto",
  width: "100%",
  padding: 12,
  borderRadius: 14,
  border: "none",
  cursor: "pointer",
  background: "rgb(105, 7, 0)",
  color: "#fff",
  fontWeight: 900,
};